module.exports = __webpack_public_path__ + "static/media/login-bg.af6c1d95.png";